export const UMOGALLERY_SEARCH_RETRIEVE = 'UMOGALLERY_SEARCH_RETRIEVE';
export const UMOGALLERY_CLEAR_SEARCH = 'UMOGALLERY_CLEAR_SEARCH';
export const UMOGALLERY_FILTER_RETRIEVE = 'UMOGALLERY_FILTER_RETRIEVE';
export const UMOGALLERY_UPDATE_PREV_SEARCH = 'UMOGALLERY_UPDATE_PREV_SEARCH';

export const UMOGALLERY_SEARCH_SUCCESS = 'UMOGALLERY_SEARCH_SUCCESS';
export const UMOGALLERY_SEARCH_FAILURE = 'UMOGALLERY_SEARCH_FAILURE';

export const UMOGALLERY_UPDATE_UMOSPERPAGE_RETRIEVE =
  'UMOGALLERY_UPDATE_UMOSPERPAGE_RETRIEVE';
export const UMOGALLERY_UPDATE_SORTBY_RETRIEVE =
  'UMOGALLERY_UPDATE_SORTBY_RETRIEVE';
export const UMOGALLERY_UPDATE_PAGE_RETRIEVE =
  'UMOGALLERY_UPDATE_PAGE_RETRIEVE';

export const UMOGALLERY_CANCEL_ALL_REQUESTS = 'UMOGALLERY_CANCEL_ALL_REQUESTS';
export const UMOGALLERY_SELECT_TOGGLE = 'UMOGALLERY_SELECT_TOGGLE';
export const UMOGALLERY_SELECT_PAGE = 'UMOGALLERY_SELECT_PAGE';
export const UMOGALLERY_SELECT_SEARCH = 'UMOGALLERY_SELECT_SEARCH';
export const UMOGALLERY_DESELECT_ALL = 'UMOGALLERY_DESELECT_ALL';
export const UMOGALLERY_SET_GALLERY_TYPE = 'UMOGALLERY_SET_GALLERY_TYPE';
export const UMOGALLERY_SET_SELECTED_UMOIDS = 'UMOGALLERY_SET_SELECTED_UMOIDS';
export const UMOGALLERY_TOGGLE_FILTER_MENU = 'UMOGALLERY_TOGGLE_FILTER_MENU';

export const ADVANCED_SEARCH_SAVE = 'ADVANCED_SEARCH_SAVE';
export const ADVANCED_SEARCH_SAVE_FAILURE = 'ADVANCED_SEARCH_SAVE_FAILURE';

export const UMOGALLERY_SET_LAST_SELECTED_UMO_ID =
  'UMOGALLERY_SET_LAST_SELECTED_UMO_ID';
export const UMOGALLERY_SET_SELECTED_CATEGORY =
  'UMOGALLERY_SET_SELECTED_CATEGORY';
